import React, { Component } from 'react';
import { Divider } from 'antd';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import axios from 'axios';
import { env } from '../../env';

import './VisPage.scss';

import { Visualization } from '../../components/Visualization/Visualization';
import { VisTable } from '../../components/VisTable/VisTable';
import { NodeMenu } from '../../components/NodeMenu/NodeMenu';
import { EdgeMenu } from '../../components/EdgeMenu/EdgeMenu';

const NodeTypeDict = {
  'host': 'Host',
  'pat': 'Pathogen Protein'
}

const urlParams = new URLSearchParams(window.location.search);
const tdata = urlParams.get("resultid");

class VisPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedBar: 'table',
      currentNodeData: {},
      currentEdgeData: {},
      searchTerm: '',
      infoType: '',
      isMounted: false,
      results: {},
      params: [],
    };

    this.handleNodeClicked = this.handleNodeClicked.bind(this);
    this.handleSearchTerm = this.handleSearchTerm.bind(this);
    this.handleEdgeClicked = this.handleEdgeClicked.bind(this);
  }

  handleBarSwitch(newMenu) {
    this.setState({ selectedBar: newMenu });
  }

  handleSearchTerm(term) {
    this.setState({ searchTerm: term });
  }

  handleNodeClicked(e) {
    this.setState({ infoType: 'Node' });
    const data = e.target.data();
    const nodeType = NodeTypeDict[data.className];
    const itemName = data.id;
    const itemDegree = e.target.degree();
    let species;
    if (data.className === 'host') {
      species = this.state.results.data.requestBody.host;
    } else {
      species = this.state.results.data.requestBody.pathogen;
    }

    const parsedData = {
      nodeType,
      name: itemName,
      degree: itemDegree,
      species: species,
    };

    this.setState({ currentNodeData: parsedData }, () => {
      this.handleBarSwitch('info');
    });
  }

  handleEdgeClicked(data) {
    data['host'] = this.state.results.data.requestBody.host;
    data['pathogen'] = this.state.results.data.requestBody.pathogen;
    this.setState({ 
      infoType: 'Edge', 
      currentEdgeData: data,
    }, () => {
      this.handleBarSwitch('info');
    });
  }

  async fetchData() {
    const results = await axios
      .get(
        `${env.BACKEND}/api/network?resultsId=${tdata}`
      );
    const params = await axios
      .get(
        `${env.BACKEND}/api/params?resultsId=${tdata}`
      );
    return [results, params]
  }

  componentDidMount() {
    if (!this.state.isMounted) {
      this.setState({
        isMounted: true,
      });
      this.fetchData()
        .then(data => {
          const results = data[0];
          const paramsList = data[1].data;
          console.log(paramsList)
          let combinationType = paramsList[0].combinationType;
          if (!combinationType) {
            combinationType = paramsList[0].category;
          }
          let categories = [];
          for (let i = 0; i < paramsList.length; i++) {
            if (i === 0 && (combinationType === 'consensus' || combinationType === 'concatenation')) continue;
            let params = paramsList[i];
            categories.push(params.category)
            paramsList[params.category] = params;
          }
          this.setState({
            results: results,
            params: paramsList,
            combinationType: combinationType,
            categories: categories,
          });
        })
    }
  }

  render() {
    const { searchTerm, selectedBar, infoType, currentNodeData, currentEdgeData } = this.state;

    let tableClass = selectedBar === 'table' ? 'selected' : '';
    let nodeClass = selectedBar === 'info' ? 'selected' : '';

    let menuComponent;
    
    if (this.state.isMounted && this.state.results.data) {
      if (selectedBar === 'table') {
        menuComponent = <VisTable handleSearchChange={this.handleSearchTerm} tableRowClicked={this.handleEdgeClicked} results={this.state.results}/>;
      } else {
        menuComponent = infoType.toLowerCase() === 'node' ? 
          <NodeMenu nodeData={currentNodeData} /> :
          infoType.toLowerCase() === 'edge' ? 
            <EdgeMenu edgeData={currentEdgeData} /> :
            <div>No node or edge selected.</div>;
      }
    }
    
    return (
      <div className="container">
        <Row className='mt-4'>
          <Col sm={7}>
            {
              this.state.isMounted && this.state.results.data ?
              <Visualization edgeHandler={this.handleEdgeClicked} nodeHandler={this.handleNodeClicked} searchTerm={searchTerm} 
                results={this.state.results} categories={this.state.categories} combinationType={this.state.combinationType}/>
              :
              <>
                <br></br>
                <p>Loading network...</p>
              </>
            }
          </Col>
          <Col sm={5}>
            <div className="bar-selector mb-3">
              <span className={`${tableClass} mr-3`} onClick={() => this.handleBarSwitch('table')}>Table</span>
              <span className={nodeClass}  onClick={() => this.handleBarSwitch('info')}>{infoType}Info</span>
            </div>
            {menuComponent}
          </Col>
        </Row>
        <Divider />
      </div>
    );
  }
}

VisPage.propTypes = {
  // Define PropTypes here if needed
};

export default VisPage;
